import Head from 'next/head'
import { withTranslation } from 'server/i18n'
import PropTypes from 'prop-types'
import { NextSeo } from 'next-seo'
import { Box } from 'reflexbox'
import getConfig from 'next/config'

import PageTitle from 'components/PageTitle'
import CalculatorBlock from 'components/CalculatorBlock'

import layoutTheme from 'theme/layout-theme'

import { useMemo } from 'react'

const { publicRuntimeConfig } = getConfig()
const { CLOUDINARY_URL, DOMAIN_ROOT } = publicRuntimeConfig

const ConfigurePage = ({ t, i18n }) => {
    const seoData = useMemo(
        () => ({
            title: `${t('meta-data:configure-title')}`,
            description: t('meta-data:configure-description'),
            canonical: t('meta-data:configure-url'),
            openGraph: {
                title: `${t('meta-data:configure-title')}`,
                description: t('meta-data:configure-description'),
                url: t('meta-data:configure-url'),
                images: [
                    {
                        url: `${CLOUDINARY_URL}/v1582632369/Static/sell-image_hace64.jpg`
                    }
                ]
            },
            languageAlternates: [
                {
                    hrefLang: 'en',
                    href: `${DOMAIN_ROOT}/configure`
                },
                {
                    hrefLang: 'de',
                    href: `${DOMAIN_ROOT}/de/configure`
                }
            ]
        }),
        [i18n.language]
    )

    return (
        <div>
            <NextSeo {...seoData} />
            <Head>
                <script
                    language="javascript"
                    type="text/javascript"
                    /* eslint-disable-next-line react/no-danger */
                    dangerouslySetInnerHTML={{
                        __html: `(function (id, f, t, ws, ms_tr_il_08, ms_tr_il_w_01) { var tr = function (cb) { var count = 0; var callback = function () { if (count == 0) { count++; if (w) { w.w(id, t, cb); } } }; var ts = document.createElement('script'); ts.src = ws; ts.type = 'text/javascript'; ts.onload = callback; ts.onreadystatechange = function () { if (this.readyState == 'complete' || this.readyState == 'loaded') { callback(); } }; var head = document.getElementsByTagName('head')[0]; head.appendChild(ts); }; if (typeof ms_tr_il_08 === 'function') { if (ms_tr_il_w_01 === null) { tr(function() { ms_tr_il_08(id, f, t); }); } else { ms_tr_il_w_01.w(id, t, function(websiteVisitedParams) { ms_tr_il_08(id, f, t, websiteVisitedParams); }, null); } } else { tr(); }})('kBAM47FuW-dk9EuEOQ_fHpnv95N23L2ly5CuvHZauu0', 'https://a78037f57059413b89ee955ac3aa54f4.svc.dynamics.com/f', 'https://a78037f57059413b89ee955ac3aa54f4.svc.dynamics.com/t', 'https://a78037f57059413b89ee955ac3aa54f4.svc.dynamics.com/t/w', typeof ms_tr_il_08 === "undefined" ? null : ms_tr_il_08, typeof ms_tr_il_w_01 === "undefined" ? null : ms_tr_il_w_01);`
                    }}
                />
            </Head>

            <Box
                theme={layoutTheme}
                px={[20, 20, 20, 40, 40]}
                mt={[35, null, 70, 100, 150]}
                mb={[35, null, 70, 80]}
                maxWidth="1040px"
                mx="auto">
                <PageTitle
                    title={t('configure-page:configure-title')}
                    lead={t('configure-page:configure-lead')}
                    titleTag="h1"
                    isLeadFullWidth
                />
            </Box>

            <Box
                theme={layoutTheme}
                px={[0, 0, 0, 20, 20]}
                mt={[0, 0, 80, 80]}
                mb={[0, null, null, 120]}
                maxWidth="1360px"
                mx="auto">
                <CalculatorBlock
                    title1={t('configure-page:select-type-of-hul')}
                    title2={t('configure-page:select-hull-material')}
                    title3={t('configure-page:yacht-details')}
                    subtitle3={t('configure-page:subtitle-3')}
                    title4={t('configure-page:select-your-services')}
                    subtitle4={t('configure-page:subtitle-4')}
                    title5={t('configure-page:receive-your-personalized-offer')}
                    subtitle5={t('configure-page:subtitle-5')}
                    title6={t('configure-page:thank-you')}
                    subtitle6={t('configure-page:subtitle-6')}
                    buttonIcon
                    buttonText={t('configure-page:calculator-button')}
                    t={t}
                />
            </Box>
        </div>
    )
}

ConfigurePage.propTypes = {
    i18n: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    t: PropTypes.func.isRequired
}

export default withTranslation(['common', 'configure-page', 'manage-page', 'meta-data'])(ConfigurePage)
